import { useEffect, useRef, useState } from 'react';
import {
    VictoryArea,
    VictoryAxis,
    VictoryChart,
    VictoryLabel,
    VictoryTheme,
    VictoryTooltip,
    VictoryVoronoiContainer,
} from 'victory';
import { useDict } from '../../../contexts/LanguageContext';

function formatNetReturn(dataDictionary) {
    const formatted = Object.entries(dataDictionary).map(([month, data]) => ({
        month,
        netReturn: data.net_return,
    }));

    return formatted;
}

function getDatumAmount(datum) {
    if (datum.netReturn === "0.00") {
        return '0.00';
    }

    return parseFloat(datum.netReturn.toFixed(2)).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

const PerformanceChart = (props) => {
    const { graphData } = props;

    const dict = useDict();

    const parentRef = useRef(null);

    const [isEmptyYAxis, setIsEmptyYAxis] = useState(false);

    const parsedData = formatNetReturn(graphData);

    useEffect(() => {
        const dataArray = Object.values(parsedData);
        const isZero = !dataArray.some((data) => data.netReturn !== 0);

        setIsEmptyYAxis(isZero);
    }, []);

    return (
        <div className='performance-chart-div' ref={parentRef}>
            <VictoryChart
                theme={VictoryTheme.material}
                // animate={{ onLoad: { duration: 1000 } }}
                width={
                    window.innerWidth >= 1200
                        ? 1200
                        : window.innerWidth >= 992
                            ? 992
                            : window.innerWidth
                }
                height={260}
                padding={{
                    left: 74,
                    top: 35,
                    right: 48,
                    bottom: 52,
                }}
                containerComponent={
                    <VictoryVoronoiContainer
                        labels={({ datum }) =>
                            `${datum.month
                            } \n ${dict.amount}: ฿ ${getDatumAmount(datum)}`
                        }
                        labelComponent={
                            <VictoryTooltip
                                constrainToVisibleArea
                                flyoutStyle={{
                                    stroke: 'white',
                                    fill: 'white',
                                    strokeWidth: 1,
                                }}
                                flyoutPadding={5}
                                style={{
                                    fill: 'rgb(239, 117, 65)',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    whiteSpace: 'nowrap',
                                }}
                            />
                        }
                    />
                }
            >
                <VictoryAxis
                    style={{
                        tickLabels: { fontSize: 12, fill: 'white' },
                        grid: { opacity: 0.7 },
                    }}
                />
                <VictoryAxis
                    dependentAxis
                    tickFormat={(t) => Math.round(t / 1).toLocaleString()}
                    tickValues={
                        isEmptyYAxis ? [20, 40, 60, 80, 100] : undefined
                    }
                    axisLabelComponent={
                        <VictoryLabel
                            dy={-52}
                            style={{
                                fontWeight: 'bold',
                                fontFamily: 'roboto, sans-serif',
                                fill: 'white',
                            }}
                        />
                    }
                    label="฿"
                    style={{
                        tickLabels: { fontSize: 12, fill: 'white' },
                        axisLabel: { fontSize: 12, fill: 'white' },
                        grid: { opacity: 0.7 },
                    }}
                    theme={VictoryTheme.material}
                    standalone={false}
                />
                <VictoryArea
                    style={{
                        data: {
                            fill: 'orange',
                            fillOpacity: 0.7,
                            stroke: 'darkOrange',
                            strokeWidth: 2,
                        },
                    }}
                    data={parsedData}
                    x="month"
                    y="netReturn"
                    interpolation="monotoneX"
                />
            </VictoryChart>
        </div>
    );
};

export default PerformanceChart;
